import React from 'react';
import {Button, Container, Divider, Grid, Header} from "semantic-ui-react";
import "../components/common/KontaktBoks.css";
import ImageLink from "./common/ImageLink";
import appRoutes from "../routes/appRoutes";
import LetsikringVedKritiskSygdomImg from "../images/letsikringvedkritisksygdom.jpg";
import LetsikringAfHelbredImg from "../images/letsikringafhelbred.jpg";

const Kontakt = props => {

    return (
        <div>
            <Header as="h1" textAlign="center">Brug din forsikring</Header>
            <Divider hidden/>
            <Container text>

                <p>Vil du en anmelde en skade, skal det ske til PFA Pension, som Letpension formidler pensions- og
                    forsikringsløsninger for.
                </p>
                <p>Du skal gøre det via PFA Pension’s digitale skadesanmeldelse. Hvis du har spørgsmål, inden du
                    anmelder en skade, kan du kontakte PFA Pension.
                </p>
                <Divider hidden/>
                <Button color="teal" as="a" href="https://mit.pfa.dk/" target="blank">Anmeld skade</Button>
                <Divider hidden/>

                <p><b>Ring på:</b></p>
                <table>
                    <tr>
                        <td style={{width:100}}>7012 5000,</td>
                        <td>hvis du har brug for behandling</td>
                    </tr>
                    <tr>
                        <td style={{verticalAlign:'baseline'}}>7012 5000,</td>
                        <td>hvis du er blevet syg og ønsker hjælp og rådgivning fra EarlyCare (alle kunder med en
                            Letsikring ved sygdom har adgang til EarlyCare).</td>
                    </tr>
                    <tr>
                        <td>7012 5000,</td>
                        <td>hvis du vil anmelde sygdom</td>
                    </tr>
                    <tr>
                        <td>7012 5000,</td>
                        <td>hvis du vil anmelde kritisk sygdom</td>
                    </tr>
                    <tr>
                        <td>3917 5656,</td>
                        <td>hvis du vil anmelde et dødsfald</td>
                    </tr>
                </table>

                <Divider hidden/>

                <p>Bemærk, at hvis du mister én, der står dig nær, behøver du normalt ikke anmelde dødsfaldet til PFA
                    Pension. PFA Pension får besked fra det danske folkeregister, medmindre personen ikke er tilmeldt
                    dette.</p>
            </Container>

            <Divider hidden/>
            <Divider hidden/>

            <Grid centered stackable columns={2}>
                <Grid.Row>
                    <ImageLink imageSrc={LetsikringAfHelbredImg} text="Letsikring af helbred" link={appRoutes.LETSIKRING_AF_HELBRED}/>
                    <ImageLink imageSrc={LetsikringVedKritiskSygdomImg} text="Letsikring ved kritisk sygdom" link={appRoutes.LETSIKRING_VED_KRITISK_SYGDOM}/>
                </Grid.Row>
            </Grid>


        </div>

    );
};

export default Kontakt;
